module.exports = __webpack_public_path__ + "static/img/5.a704496.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/5/4/eng/5.png
// module id = 2xBW
// module chunks = 0